var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.3 16.3",
    style: {
      enableBackground: "new 0 0 16.3 16.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFA50D;stroke:#FFA50D;stroke-width:0.3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.16 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.7,6.7c-0.3,0-0.5,0.1-0.5,0.3v6.1c0,0.2,0.2,0.3,0.5,0.3s0.5-0.1,0.5-0.3V7.1C11.2,6.9,11,6.7,10.7,6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.3,6.7C5,6.7,4.8,6.9,4.8,7.1v6.1c0,0.2,0.2,0.3,0.5,0.3s0.5-0.1,0.5-0.3V7.1C5.7,6.9,5.5,6.7,5.3,6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.3,5.1v8.8c0,0.6,0.2,1.1,0.7,1.5C2.4,15.8,3,16,3.6,16h8.7c0.6,0,1.2-0.2,1.6-0.6c0.4-0.4,0.7-0.9,0.7-1.5 V5.1C15.5,5,16.1,4.2,16,3.4c-0.2-0.8-0.9-1.4-1.8-1.3h-2.4V1.6c0-0.4-0.2-0.8-0.5-1.1C11,0.2,10.5,0,10,0H5.9C5.5,0,5,0.2,4.7,0.5 C4.3,0.7,4.1,1.1,4.1,1.6v0.5H1.8C0.9,2,0.2,2.6,0,3.4C-0.1,4.2,0.5,5,1.3,5.1L1.3,5.1z M12.4,15.2H3.6c-0.7,0-1.4-0.6-1.4-1.3 c0,0,0,0,0,0V5.1h11.5v8.7C13.8,14.6,13.1,15.2,12.4,15.2C12.4,15.2,12.4,15.2,12.4,15.2L12.4,15.2z M5,1.6C5,1.4,5.1,1.2,5.3,1 C5.5,0.9,5.7,0.8,6,0.8h4.1c0.2,0,0.5,0.1,0.6,0.2C10.9,1.2,11,1.4,11,1.6v0.5H5V1.6z M1.8,2.9h12.5c0.4,0,0.8,0.3,0.8,0.7 c0,0.4-0.4,0.7-0.8,0.7H1.8C1.3,4.4,1,4,0.9,3.6C1,3.2,1.3,2.9,1.8,2.9L1.8,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,6.7c-0.3,0-0.5,0.1-0.5,0.3v6.1c0,0.2,0.2,0.3,0.5,0.3s0.5-0.1,0.5-0.3V7.1C8.5,6.9,8.3,6.7,8,6.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.16dfb3d1.svg";
export { ForwardRef as ReactComponent };